import React from 'react';

function UsersList({ users, userStats, selectedUserId, onSelectUser, isAdmin,
                    portalUsers, onLinkUser }) {
  return (
    <div className="dashboard-card third-width">
      <h2>Active Users ({users.length})</h2>
      <div className="user-list">
        {users.map((user) => {
          const stats = userStats[user.user_id] || { messages_sent: 0, messages_failed: 0 };
          const tickerCount = Object.keys(user.ticker_thresholds || {}).length;
          const isSelected = selectedUserId === user.user_id;

          return (
            <div
              key={user.user_id}
              className={`user-item selectable${isSelected ? ' selected' : ''}`}
              onClick={() => onSelectUser(isSelected ? null : user.user_id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelectUser(isSelected ? null : user.user_id);
                }
              }}
              title={isSelected ? 'Click to close the editor' : 'Click to view and edit tickers'}
            >
              <div>
                <div style={{ fontWeight: 'bold' }}>
                  {user.telegram_name || user.telegram_username
                    ? (user.telegram_name || `@${user.telegram_username}`)
                    : `User ${user.user_id}`}
                </div>
                <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                  id {user.user_id}
                  {user.telegram_username && user.telegram_name ? ` • @${user.telegram_username}` : ''}
                </div>
                <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                  {tickerCount} tickers • {stats.messages_sent} sent • {stats.messages_failed} failed
                </div>
                {isAdmin && (
                  <div
                    style={{ marginTop: '6px' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <select
                      className="editor-input link-select"
                      value={user.portal_username || ''}
                      onChange={(e) => onLinkUser(user.user_id, e.target.value)}
                      title="Portal account allowed to edit this list"
                    >
                      <option value="">— not linked —</option>
                      {portalUsers.map((p) => (
                        <option key={p} value={p}>{p}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: '0.875rem', color: '#27ae60' }}>
                  Chat: {user.chat_id}
                </div>
                <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                  {isSelected ? 'editing' : 'edit tickers'}
                </div>
                {!isAdmin && user.portal_username && (
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                    {user.portal_username}
                  </div>
                )}
              </div>
            </div>
          );
        })}
        {users.length === 0 && (
          <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-secondary)' }}>
            {isAdmin
              ? 'No active users'
              : 'No Telegram account is linked to your login yet'}
          </div>
        )}
      </div>
    </div>
  );
}

export default UsersList;
